import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const externalDeliveryFileUpdateService = (data: any) => {
  return axiosInstance
    .put(ENDPOINTS.ADMIN.EXTERNAL_DELIVERY.UPDATE_FILE, data)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
